import i18n from '@/i18n';
import auth from '@/utils/auth';
import { uuid } from 'vue-uuid';

import { HTTP_EDOCPERSO, HTTP_NEW_EDOCPERSO } from '../../../http';
import * as types from './types';
import store from '../../index';
import trackingServices from '../../../plugins/posthog';


export default {
  setMIPIH({ commit }, isMIPIH) {
    commit(types.SET_MIPIH, isMIPIH);
  },

  // Initialize FranceConnect V2
  initFranceConnect({ commit, state }) {
    if (state.franceConnectData) {
      return Promise.resolve(state.franceConnectData);
    }

    if (store.state.conf.BO_IS_V2) {
      return HTTP_NEW_EDOCPERSO.get('/franceconnect/init')
        .then((response) => {
          const data = response.data;
          commit(types.SET_FRANCE_CONNECT_DATA, data);
          return data;
        });
    }

    // Fallback V1 behavior
    return auth.getConf().then((response) => {
      const fcState = uuid.v4();
      let fcUrl = `${response.CONF.FRANCE_CONNECT_HOST}/api/v2/authorize?`;
      fcUrl += `client_id=${response.CONF.FRANCE_CONNECT_CLIENT_ID}`;
      fcUrl += `&redirect_uri=${encodeURIComponent(`${window.location.origin}/fc-callback`)}`;
      fcUrl += `&response_type=code&scope=email%20openid%20given_name%20family_name&state=${fcState}&nonce=${uuid.v4()}`;
      fcUrl += '&acr_values=eidas1';
      const data = { authorizeUrl: fcUrl };
      commit(types.SET_FRANCE_CONNECT_DATA, data);
      return data;
    });
  },

  // log in function
  login({ dispatch, commit }, params) {
    if (store.state.conf.BO_IS_V2) {
      return HTTP_NEW_EDOCPERSO.post('/authenticate', params)
        .then((response) => {
          if (response.data.code === 5) {
            dispatch('application/loadingTrigger', false, { root: true });
            commit(types.SET_EDPV3_USER_MESSAGE, { edpv3UserMessage: 'alert.edpv3' });
          }
          return response.data;
        });
    }

    return HTTP_EDOCPERSO.post('/index.php?api=Authenticate&a=doAuthentication', params)
      .then(response => response.data);
  },

  loginWithFranceConnect({ dispatch, commit }, params) {
    if (store.state.conf.BO_IS_V2) {
      // V2: Utiliser seulement code et state
      const v2Params = {
        code: params.code,
        state: params.state,
      };
      return HTTP_NEW_EDOCPERSO.post('/authenticateWithFranceConnect', v2Params)
        .then((response) => {
          if (response.data.code === 5) {
            dispatch('application/loadingTrigger', false, { root: true });
            commit(types.SET_EDPV3_USER_MESSAGE, { edpv3UserMessage: 'alert.edpv3' });
          }
          return response.data;
        });
    }

    // V1: Utiliser tous les paramètres
    return HTTP_EDOCPERSO.post('/index.php?api=Authenticate&a=authenticateWithFranceConnect', params)
      .then(response => response.data);
  },

  sendActivationCode({ dispatch }, params) {
    return HTTP_NEW_EDOCPERSO.post('/edpUser/sendActivationCode', params)
      .then((response) => {
        dispatch('application/displayAlert',
          {
            text: i18n.t('activate.send.activation.code.alert'),
            time: 20,
            centered: true,
          },
          { root: true });
        return response.data;
      });
  },
  // ** Activation methods **
  checkActivationCode({ dispatch, commit }, params) {
    if (store.state.conf.BO_IS_V2) {
      return HTTP_NEW_EDOCPERSO.post('/authenticate/checkActivationCode', params)
        .then((response) => {
          if (response.data.code === 5) {
            dispatch('application/loadingTrigger', false, { root: true });
            commit(types.SET_EDPV3_USER_MESSAGE, { edpv3UserMessage: 'alert.edpv3' });
          }
          return response;
        });
    }

    return HTTP_EDOCPERSO.post('/index.php?api=Authenticate&a=checkActivationCode', params)
      .then(response => response);
  },
  sendActivation({ dispatch, commit }, params) {
    if (store.state.conf.BO_IS_V2) {
      HTTP_NEW_EDOCPERSO.defaults.headers.Authorization = params.sessionId;
      return HTTP_NEW_EDOCPERSO.post('/edpUser/finalize', params)
        .then((response) => {
          if (response.data.code === 5) {
            dispatch('application/loadingTrigger', false, { root: true });
            commit(types.SET_EDPV3_USER_MESSAGE, { edpv3UserMessage: 'alert.edpv3' });
          }
          return response.data;
        });
    }

    HTTP_EDOCPERSO.defaults.headers.Authorization = params.sessionId;
    return HTTP_EDOCPERSO.post('/index.php?api=User&a=finalize', params)
      .then(response => response.data);
  },
  sendRegistration(context, params) {
    if (store.state.conf.BO_IS_V2) {
      return HTTP_NEW_EDOCPERSO.post('/edpUser/create', params)
        .then(response => response.data);
    }

    return HTTP_EDOCPERSO.post('/index.php?api=User&a=create', params)
      .then(response => response.data);
  },
  // ** Recover password **
  getRecoveryQuestion(context, params) {
    if (store.state.conf.BO_IS_V2) {
      return HTTP_NEW_EDOCPERSO.post('/edpUser/secretQuestion', params)
        .then(response => response.data);
    }

    return HTTP_EDOCPERSO.post('/index.php?api=User&a=getSecretQuestion', params)
      .then(response => response.data);
  },
  sendCodeToResetPassword({ dispatch }, params) {
    return HTTP_NEW_EDOCPERSO.post('/edpUser/reinitializePassword', params)
      .then((response) => {
        dispatch('application/displayAlert',
          {
            text: params.sendByEmail ? i18n.t('login.pawdLost.alert.code.email') : i18n.t('login.pawdLost.alert.code.sms'),
            time: 10,
            centered: true,
          },
          { root: true });
        return response.data;
      });
  },
  resetPassword({ dispatch }, params) {
    return HTTP_NEW_EDOCPERSO.post('/edpUser/initializePassword', params)
      .then(response => response.data)
      .catch((error) => {
        if (error.response.data.code === 100) {
          dispatch('application/displayError',
            {
              text: i18n.t('login.pawdLost.code.alert.incorrect'),
              time: 10,
              centered: true,
              fullWidth: true,
            },
            { root: true });
        }
        if (error.response.data.code === 110) {
          dispatch('application/displayError',
            {
              text: i18n.t('login.pawdLost.code.alert.expired'),
              time: 10,
              centered: true,
            },
            { root: true });
        }
        if (error.response.data.code === 120) {
          dispatch('application/displayError',
            {
              text: i18n.t('login.pawdLost.code.alert.five.incorrect.trials'),
              time: 10,
              centered: true,
            },
            { root: true });
        }
        if (error.response.data.code === 130) {
          dispatch('application/displayError',
            {
              text: i18n.t('login.pawdLost.code.alert.invalid.pwd'),
              time: 10,
              centered: true,
            },
            { root: true });
        }
        throw error;
      });
  },
  sendEmailValidationCode({ dispatch }, params) {
    return HTTP_NEW_EDOCPERSO.post('/edpUser/sendEmailValidationCode', params)
      .then((response) => {
        dispatch('application/displayAlert', { text: i18n.t('activate.alert.mail.code'), time: 10, centered: true }, { root: true });
        return response.data;
      })
      .catch((error) => {
        let errorMessage = '';
        if (error.response) {
          if (error.response.data.code === 140) {
            errorMessage = 'activate.alert.send.code.error.mail';
          } else if (error.response.data.code === 150) {
            errorMessage = 'activate.alert.send.code.limit';
          } else {
            errorMessage = 'error.message.default';
          }
          dispatch('application/displayError', { text: i18n.t(errorMessage), time: 10, centered: true, fullWidth: true }, { root: true });
        }
        return Promise.reject(error);
      });
  },
  verifyEmailValidationCode({ dispatch }, params) {
    return HTTP_NEW_EDOCPERSO.post('/edpUser/verifyEmailValidationCode', params)
      .then((response) => {
        trackingServices.accountActivationEmailVerifiedSuccessfully(response.data.email);
        return response.data;
      })
      .catch((error) => {
        let errorMessage = '';
        trackingServices.accountActivationEmailVerifiedFailed({ code: error.response.data.code, content: error.response.data.content.errors });
        if (error.response) {
          if (error.response.data.code === 110) {
            errorMessage = 'activate.alert.mail.code.expired';
          } else if (error.response.data.code === 120) {
            errorMessage = 'activate.alert.mail.code.wrong';
          } else if (error.response.data.code === 140) {
            errorMessage = 'activate.alert.mail.code.attempt.limit';
          } else {
            errorMessage = 'error.message.default';
          }
          dispatch('application/displayError', { text: i18n.t(errorMessage), time: 10, centered: true }, { root: true });
        }
        return Promise.reject(error);
      });
  },


};




// WEBPACK FOOTER //
// ./src/store/modules/authentification/actions.js